import type { EntityID, ValueOrMatcher } from '@wovin/core/applog'
import type { Accessor } from 'solid-js'
import type { Thread } from '@wovin/core/thread'
import { queryAndMap } from '@wovin/core'
import { useLiveFilterAndMap, useSubscribable } from '@wovin/hooks-solid'
import { Logger } from 'besonders-logger'
import { createEffect } from 'solid-js'
import { useCurrentThread } from '../ui/reactive'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO) // eslint-disable-line/no-unused-vars

export function getProviderIDs(
	type: ValueOrMatcher<string> = undefined,
	thread: Thread = useCurrentThread(),
) {
	const providers = queryAndMap(thread, [
		{ at: 'wovin/provider/type', vl: type as any },
	], 'en') as readonly EntityID[]

	DEBUG(`[getProviderIDs] result`, [...providers])
	return providers
}

export function useProviderIDs(
	type: ValueOrMatcher<string> = undefined,
	thread: Thread = useCurrentThread(),
) {
	const providerIDsub = useLiveFilterAndMap(
		{ at: 'wovin/provider/type', vl: type as any },
		'en',
		{ thread },
	)
	createEffect(() => DEBUG.force({ providerIds: providerIDsub() }))
	const currentThreadSubscription = useSubscribable(thread)
	createEffect(() => DEBUG.force({ currentThreadSubscription: currentThreadSubscription() }))

	return providerIDsub as Accessor<readonly EntityID[]>
}
